module.exports = __webpack_public_path__ + "static/media/2.687a3451.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/remoteSmartLinkIOT/img/2.png
// module id = 465
// module chunks = 0